const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://vibeflow-gy48.onrender.com';

export default API_BASE_URL;
